import { ConvDivComboBoxComponent } from './conv-div-combo-box.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * カテゴリ変換区分コンボボックスモデル
 *
 * @export ConvDivComboBoxModel
 * @class ConvDivComboBoxModel
 */
export class ConvDivComboBoxModel {

  // カテゴリ変換区分リスト
  public codeList: Array<any>;
  // カテゴリ変換区分リスト
  public convDivList = [];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // コンボボックスインスタンス
  public component: ConvDivComboBoxComponent;
  // 初期設定コード値
  public setConvDiv: string;
  // 初期設定インデックス
  public setSelectedIndex: number = <number>-1;
  // 初期データ自動取得フラグ
  public initAutoLoad = true;


  /**
   * カテゴリ変換区分リストを更新する
   *
   * @param {*} serverData
   * @memberof ConvDivComboBoxModel
   */
  public updateConvDivList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankObject('', ''));
      index = 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].ConvDivName = tempDataList[index].ConvDiv + ':' + tempDataList[index].ConvName;
    }

    this.convDivList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedConvDiv();
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @param {string} convDiv カテゴリ変換区分
   * @param {string} convName カテゴリ変換名
   * @returns {object} オブジェクト
   * @memberof ConvDivComboBoxModel
   */
  private getBlankObject(convDiv: string, convName: string): object {
    const ob: any = {};
    ob.CategoryDiv = '';
    ob.ConvDiv = convDiv;
    ob.ConvName = convName;
    ob.ConvDivName = '';
    if (!PlessViewUtilsSub.isEmpty(String(convDiv)) && !PlessViewUtilsSub.isEmpty(String(convName))) {
      ob.ConvDivName = convDiv + ':' + convName;
    } else {
      ob.ConvDivName = convDiv.concat(convName);
    }
    ob.ClassCodeCtrl = '';
    ob.LargeClassCodeCtrl = '';
    ob.MiddleClassCodeCtrl = '';
    ob.SmallClassCodeCtrl = '';
    ob.MarkCode1Ctrl = '';
    ob.MarkCode2Ctrl = '';
    ob.MarkCode3Ctrl = '';
    ob.PricePatternCtrl = '';
    ob.MediumTypeCtrl = '';
    ob.FeatureCodeCtrl = '';
    ob.PromotionInfoCtrl = '';
    ob.PageNumCtrl = '';
    ob.ExhibitionDivCtrl = '';
    ob.Tag1Ctrl = '';
    ob.Tag2Ctrl = '';
    ob.DnaDiv1Ctrl = '';
    ob.DnaDiv2Ctrl = '';
    ob.DnaDiv3Ctrl = '';
    return ob;
  }

}
